import { editorialRequest } from 'app/config/editorialRequest.config';

export function getProgramCustomStyles(courseId) {
  return editorialRequest('read', 'get', `v3/courses/${courseId}/custom_styles`);
}

export function createProgramCustomStyles(courseId, params) {
  return editorialRequest('write', 'post', `v3/courses/${courseId}/custom_styles`, params);
}

export function updateProgramCustomStyles(courseId, params) {
  return editorialRequest('write', 'put', `v3/courses/${courseId}/custom_styles`, params);
}
